<template>
    <div class="row">
        <div class="col">
            <div class="row">
                <div v-if="savings >=1" class="col result">
                    <p class="paragraph result__text--large">Save up to {{savings | currency}} per year* by switching to
                        an EV.</p>
                    <p class="paragraph result__text--small">Based on your chosen EV and mileage, your energy costs
                        could be as little as {{evRunningCost | currency}} per year.</p>
                </div>
                <div v-else class="col result result--negative">
                    <p class="paragraph result__text--info">Based upon the fuel and electricity costs you have entered
                        there
                        is
                        no saving in fuel cost by switching to an EV. Please check the costs you have entered, as low
                        running
                        costs are one of the major benefits of EVs. For details on other areas where EVs will save you
                        money,
                        why not read our Electric car and van maintenance guide.</p>
                    <a class="button button--solid" target="_blank"
                       href="https://www.vwfsfleet.co.uk/electric-car-maintenance-guide/" @click="logCTA">READ OUR GUIDE</a>
                </div>
            </div>
            <legal></legal>
        </div>

    </div>

</template>

<script>
    import Legal from './Legal'

    export default {
        name: "Result",
        components: {
            Legal
        },
        data() {
            return {
                eVCosts: 0,
                eVSavings: 0
            }
        },
        methods:{
            calculateRequiredUnits: function(consumption) {
                return this.$store.state.MILEAGE * consumption;
            },
            kWhPerMile: function() {
                return this.$store.state.SELECTED_VEHICLE.battery / this.$store.state.SELECTED_VEHICLE.range;
            },
            costPerGallon: function(cost){
                return cost * this.$store.state.LTG_CONVERSION;
            },
            logCTA: function() {
                this.$gtag.logCTA('EV Cost Savings widget - EV-4-ME - https://www.vwfsfleet.co.uk/electric-vs-petrol-car-advisor/');
            },
            setProxySaving: function(value) {
                this.eVSavings = value;
            },
            setProxyCost: function(value) {
                this.eVCosts = value;
            }
        },
        computed: {
            petrolRunningCost: function(){
                let vehicleType = this.$store.state.VEHICLE_TYPE;
                let usage = this.calculateRequiredUnits(1/this.$store.state.GENERIC_VEHICLES[vehicleType].petrol);
                return usage * this.costPerGallon(this.$store.state.FUEL_PRICE_PETROL);
            },
            dieselRunningCost: function() {
                let vehicleType = this.$store.state.VEHICLE_TYPE;
                let usage = this.calculateRequiredUnits(1/this.$store.state.GENERIC_VEHICLES[vehicleType].diesel);
                return usage * this.costPerGallon(this.$store.state.FUEL_PRICE_DIESEL);
            },
            evRunningCost: function() {
                let runningCost = null;
                if (this.isValid) {
                    let usage = this.calculateRequiredUnits(this.kWhPerMile());
                    runningCost = usage * this.$store.state.FUEL_PRICE_ELECTRIC;
                    this.setProxyCost(runningCost)
                }

                return (runningCost || this.eVCosts);
            },
            savings: function() {
                let saving = null;
                if (this.isValid) {
                    saving = (this.$store.state.FUEL_TYPE === "petrol") ? (this.petrolRunningCost - this.evRunningCost) : (this.dieselRunningCost - this.evRunningCost);
                    this.setProxySaving(saving);
                }

                return (saving || this.eVSavings);
            },
            isValid: function () {
                if (Object.entries(this.$store.state.ERRORS).length !== 0 && this.$store.state.ERRORS.constructor === Object) {
                    if (Object.entries(this.$store.state.ERRORS).length === 1 && this.$store.state.ERRORS.petrol && this.$store.state.FUEL_TYPE === "diesel") {
                        return true;
                    } else if (Object.entries(this.$store.state.ERRORS).length === 1 && this.$store.state.ERRORS.diesel && this.$store.state.FUEL_TYPE === "petrol") {
                        return true;
                    } else {
                        return false;
                    }
                }
                return true;
            }
        },
        filters: {
            currency: function(value) {
                return '£' + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').slice(0,-3);
            }
        }
    }
</script>

<style scoped lang="stylus">
    .result
        background-color $color-blue-petrol
        color $color-white
        padding 2rem
        text-align center
        font-family $font-regular
        font-weight bold
        &__text
            &--large
                font-size 2.8rem
                line-height 3.6rem

            &--small
                font-size 2.4 rem
                line-height 3.2rem

            &--info
                font-size 2.9rem
                line-height 4.5rem
        &--negative
            padding-bottom 3.6rem
</style>